import "./questionsbox.css";
import parse from "html-react-parser";
import { Button, IconButton } from "@mui/material";
import EditModal from "../../../widgets/ratulModal/editModal";
import { useState, useEffect } from "react";
import { cleanO } from "../../../../utilities/utility";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SimpleDeleteDialog from "../../../widgets/ratulModal/simpleDeleteDialog";
import SimpleEditModal from "../../../widgets/ratulModal/simpleEditModal";
const ViewQuestionBox = (props) => {
  const {
    q,
    showAns,
    onQnDeleted,
    onEdited,
    qnum,
    setImageUrl,
    setIsOpen,
    page,
  } = props;
  const [showModal, setShowModal] = useState(false);
  const [dopen, setDopen] = useState(false);
  const remove = () => {
    setDopen(!dopen);
  };
  const edit = () => {
    setShowModal(true);
  };
  const deleteQn = () => {
    setDopen(false);
    onQnDeleted(q.question_id);
  };
  const edited = (qn) => {
    onEdited(qn);
  };

  useEffect(() => {
    const optionContainer = document.querySelector(
      `.v_opn_opn[data-qno="${qnum}"]`
    );
    const qContainer = document.querySelector(`.v_qn_qn[data-qno="${qnum}"]`);

    const handleImageClick = (event) => {
      console.log("clicked");
      if (event.target.tagName === "IMG") {
        const clickedImageSrc = event.target.src;
        //console.log("Clicked "+clickedImageSrc);
        setImageUrl(clickedImageSrc);
        setIsOpen(true);
      }
    };

    if (optionContainer) {
      optionContainer.addEventListener("click", handleImageClick);
    }

    if (qContainer) {
      qContainer.addEventListener("click", handleImageClick);
    }

    return () => {
      if (optionContainer) {
        optionContainer.removeEventListener("click", handleImageClick);
      }
      if (qContainer) {
        qContainer.removeEventListener("click", handleImageClick);
      }
    };
  }, [q]);
  return (
    <div className="view_question">
      <SimpleDeleteDialog
        dopen={dopen}
        setDopen={setDopen}
        onQnDeleted={deleteQn}
      />
      <SimpleEditModal
        toEditQ={q}
        showModal={showModal}
        onEdited={edited}
        setShowModal={setShowModal}
      />
      {page !== "single_preview" && (
        <div className="v_action_qn">
          <IconButton
            className="tk-icon-button"
            onClick={remove}
            aria-label="delete"
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
          <IconButton
            className="tk-icon-button"
            onClick={edit}
            aria-label="edit"
          >
            <EditIcon fontSize="small" />
          </IconButton>
        </div>
      )}
      <div className="v_qn_qn" data-qno={qnum}>
        <span className="qnum_c">{`Q ${qnum}.`}</span>{" "}
        {parse(cleanO(q.question))}
      </div>
      <div
        className="v_opn_opn"
        data-qno={qnum}
        style={{ display: showAns ? "initial" : "none" }}
      >
        <div className="v_option">
          <div className={q.options[0].isCorrect ? "answer" : ""}>
            A) {parse(cleanO(q.options[0].option))}
          </div>
        </div>
        <div className="v_option">
          <div className={q.options[1].isCorrect ? "answer" : ""}>
            B) {parse(cleanO(q.options[1].option))}
          </div>
        </div>
        <div className="v_option">
          {q.options.length > 2 && (
            <div className={q.options[2].isCorrect ? "answer" : ""}>
              C) {parse(cleanO(q.options[2].option))}
            </div>
          )}
        </div>
        <div className="v_option">
          {q.options.length > 3 && (
            <div className={q.options[3].isCorrect ? "answer" : ""}>
              D) {parse(cleanO(q.options[3].option))}
            </div>
          )}
        </div>
        <div className="v_option">
          {q.options.length > 4 && (
            <div className={q.options[4].isCorrect ? "answer" : ""}>
              E) {parse(cleanO(q.options[4].option))}
            </div>
          )}
        </div>
        <div className="v_option">
          {q.options.length > 5 && (
            <div className={q.options[5].isCorrect ? "answer" : ""}>
              F) {parse(cleanO(q.options[5].option))}
            </div>
          )}
        </div>
        {/* {showAns?<><div style={{borderRadius: 12, padding: '2px 10px', border: '1px solid #ccc', display: 'table', color: 'green', marginTop: 16}}>Ans: {q.Ans}</div></>:''} */}
        <div style={{ marginTop: 12, fontStyle: "italic" }}>
          Topic: {q.topic}
        </div>
      </div>
    </div>
  );
};
export default ViewQuestionBox;
